import * as React from 'react';
import AppInputError from './input-error';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: string;
  position?: 'start' | 'end';
  children?: React.ReactElement;
  endIcon?: React.ReactElement | null;
  disabled?: boolean;
  label?: string;
  required?: boolean;
  errorMessage?: string;
  maxLength: number;
}

const AppCodeInput = React.forwardRef<HTMLInputElement, InputProps>(
  (props: InputProps) => {
    const [pos, setPos] = React.useState('');
    const IconPlacement = () => {
      return props.icon === 'envelope' ? (
        <div
          className={`absolute px-4 ${props.position === 'end' ? ` right-0 ` : ''}`}
        >
          {props.children}
        </div>
      ) : props.icon === 'password' ? (
        <div
          className={`absolute px-4 ${props.position === 'end' ? ` right-0 ` : ''}`}
        >
          {props.children}
        </div>
      ) : null;
    };

    React.useEffect(() => {
      switch (props.position) {
        case 'start':
          return setPos('pl-12');
        case 'end':
          return setPos('pr-12');
        default:
          return props.icon ? setPos('pl-12') : setPos('');
      }
    }, []);

    return (
      <div>
        {props.label ? (
          <div className="mb-1 flex items-center gap-2">
            <p className="font-semibold text-xs">{props.label}</p>
            <p className={`text-red-500 ${props.required ? '' : 'invisible'}`}>
              *
            </p>
          </div>
        ) : null}

        <div
          className={`flex justify-start relative items-center rounded-xl border px-4 py-2 ${props.errorMessage ? 'border-red-500 bg-red-50' : ''}`}
        >
          {!props.position && props.icon && <IconPlacement />}
          {props.position === 'start' && props.icon && <IconPlacement />}
          <input
            type={props.type}
            className={`w-full rounded-xl text-center text-2xl placeholder:text-base tracking-[13px] placeholder:tracking-normal bg-transparent hover:outline-none focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 ${pos}`}
            {...props}
            maxLength={props.maxLength}
          />
          {props.position === 'end' && <IconPlacement />}
          {props.endIcon}
        </div>
        {props.errorMessage && <AppInputError text={props.errorMessage} />}
      </div>
    );
  },
);
AppCodeInput.displayName = 'CodeInput';

export default AppCodeInput;
